<script>
    import { onDestroy } from 'svelte';
    import { currentUser } from '../stores/user.js';
    import { navigateTo } from 'svelte-router-spa'

	onDestroy(() => {
        /*Loading animation dispears, when user data recived, if empty or logout -> go to login*/
        //  if($currentUser == undefined)
		    //    navigateTo('/login');
	});

</script>

<div class="fixed h-screen w-screen bg-gray-900 text-white text-center top-0 left-0 z-50">
    <div class="lds-ripple">
        <div></div>
        <div></div>
    </div>
</div>


<style>
.lds-ripple {
  display: inline-block;
  position: absolute;
  top:50%;
  left:50%;
  transform: translate(-50%, -50%);
  width: 160px;
  height: 160;
}
.lds-ripple div {
  position: absolute;
  border: 6px solid #fff;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}
@keyframes lds-ripple {
  0% {
    top: 72px;
    left: 72px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0px;
    left: 0px;
    width: 144px;
    height: 144px;
    opacity: 0;
  }
}
</style>